import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@home/components/SvgIcon';
import { GRStatusTag } from '@gp/components/StatusTag';
import NextMilestoneIcon from '@gp/pages/Pipeline/ProjectDetails/Milestone/components/NextMilestoneIcon';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';
import type { IBaseProps } from '@home/types/common';
import type { IMilestone } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';

interface ICardTitleProps extends IBaseProps {
  // 是否展示GR Decision标签
  showGRDecisionTag?: boolean;
  // 是否展示NextMilestone的icon
  showNextMilestoneIcon?: boolean;
  milestone?: IMilestone;
  onTitleClick?: () => void;
}

const CardTitle: React.FC<ICardTitleProps> = (props) => {
  const { style, className, showGRDecisionTag = false, showNextMilestoneIcon = false, milestone, onTitleClick } = props;

  const {
    milestone: milestoneName,
    date: milestoneDate,
    date_confirm: milestoneDateConfirm,
    gate_review: milestoneGateReview,
  } = milestone || {};

  return (
    <div
      style={style}
      className={classnames('dbg-milestone-card-title', className)}
      onClick={(e) => {
        e.stopPropagation();
        onTitleClick?.();
      }}
    >
      <SvgIcon className="dbg-milestone-card-icon" type="fill-icon-arrow" />
      <span className="dbg-milestone-card-name">
        {milestoneName || '-'}
        {/* 这里GR标识 改为 根据 is_gr 字段判断，即milestone是否打开Official Gate Review的开关 */}
        {milestone?.category === 'gr' && <span className="dbg-milestone-card-text">(GR)</span>}
        {milestone?.category === 'check_in' && <span className="dbg-milestone-card-text">(Check in)</span>}
        {showNextMilestoneIcon && <NextMilestoneIcon />}
      </span>
      <span className="dbg-milestone-card-time">
        {formatMilestoneDateByStatus(milestoneDate, milestoneDateConfirm) || '-'}
      </span>
      {showGRDecisionTag && <GRStatusTag className="dbg-milestone-card-gr-status-tag" status={milestoneGateReview} />}
    </div>
  );
};

export default CardTitle;
